// deps
import React, { memo } from "react";

// styles
import { FooterWrapper } from "./styles";

// components
import { AssistanceLink } from "./components/assistance-link";
import { TransactionCompleteBtn } from "./components/transaction-complete-btn";

// types
import { IFooter } from "@dineout-payment-success-ui/interfaces";

const Footer: React.FC<IFooter> = ({
    doneClickHandler,
    viewHelpClickHandler,
    showHelpCta = true,
    customDoneCtaText,
    isFullWidthCta = false,
}) => {
    return (
        <FooterWrapper>
            <TransactionCompleteBtn
                customDoneCtaText={customDoneCtaText}
                doneClickHandler={doneClickHandler}
                isFullWidthCta={isFullWidthCta}
            />
            {showHelpCta && <AssistanceLink viewHelpClickHandler={viewHelpClickHandler} />}
        </FooterWrapper>
    );
};

export default memo(Footer);
